export const numberOfInput = 6;
export const DEVICE_ID = '1z3dIqYRVr1EWgC9';
export const USER_ROLE = 'fiuser';
export const rateStatus = ['Pending Approval', 'Approved', 'Rejected'];
export const NotificationMessage = { fiInput: 'Veiw your CD ', ratingsAndReviews: 'View your CD Rating and Review' };
